<template>
  <div class="company animate__animated " >
    <div class="company-left">
      <div class="company-title">
        <span>公司简介</span>
      </div>
      <div class="company-content" v-html="ItemDes">
      </div>
    </div>
    <div class="company-right">
      <img :src="'http://'+ ItemImg" alt="">
      <div class="img-back"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CompanyInfo",
  data(){
    return{
      Data:{},
      ItemDes:{},
      ItemImg:{}
    }
  },
  created() {
    this.GetData()
  },
  methods:{
    GetData(){
      this.$axios.get('/api/companyIntro/getById?id=1').then(res=>{
        this.Data=res.data.data
        this.ItemDes=this.Data.description;
        this.ItemImg=this.Data.introPhotoUrl;
      })
    },
  }
}
</script>

<style  lang="less" scoped>
.company{
  width:74.5vw;
  margin:0 auto;
  min-height: 55.6vh;
  display: flex;
  justify-content: space-between;
  .company-left{
    width: 34.25vw;
    padding-left: 20px;
    .company-title{
      margin: 30px 0;
      span{
        height: 32px;
        font-size: 32px;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        font-weight: bold;
        color: #333333;
        line-height: 48px;
        letter-spacing: 1px;
      }
    }
    .company-content{
      pre{
        text-indent: 2em;
        width: 100%;
        min-height: 327px;
        font-size: 16px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #333333;
        line-height: 26px;
        white-space: pre-line;
        word-break: break-all;
      }
    }
  }
  .company-right{
    width: 33.2vw;
    margin-top: 60px;
    margin-left: 20px;
    position: relative;
    z-index: 5;
    img{
      width: 90%;
      height: 36.1vh;
    }
    .img-back{
      width: 86%;
      height: 36.1vh;
      z-index: -60;
      opacity: 0.1;
      border: 11px solid #358ED7;
      position: absolute;
      top: 30px;
      left: 40px;
    }
  }
}
</style>